import { ConfigProvider as AntConfigProvider } from "antd";
import { ConfigProviderProps } from "antd";
import nl_NL from "antd/locale/nl_NL";

import themeTokens from "./theme-tokens.json";

export default function ConfigProvider(props: Omit<ConfigProviderProps, "locale">) {
  return <AntConfigProvider {...props} theme={themeTokens} locale={nl_NL} />;
}
